import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Box } from '@uhg-abyss/web/ui/Box';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import React from 'react';

/**
 * WarningMessage
 *
 * Displays a warning message to the user when common criteria has changed.
 *
 * @param actionPath
 * @param context
 * @param criteria
 * @returns {Element}
 * @constructor
 */
export function WarningMessage({ actionPath = {}, context = '', criteria = {} }) {
  return (
    <ErrorHandler location="src/features/ActionPaths/Activation/components/WarningMessage/WarningMessage.jsx">
      <Box
        color="transparent"
        css={{
          border: '1px solid var(--abyss-colors-warning1)',
          marginBottom: 'var(--abyss-space-lg)',
        }}
      >
        <Layout.Stack alignItems="left">
          <div>
            <Layout.Group>
              <div>
                <IconSymbol color="$warning1" icon="warning" size="24px" variant="outlined" />
              </div>
              <div>
                <strong>Common Criteria: {criteria?.name} has changed</strong>
              </div>
            </Layout.Group>
          </div>
          <div>Click the Review Criteria link to review the changes.</div>
          <div>
            {context === 'entrance' && criteria?.context?.includes('entrance') && (
              <Link href={`/action-paths/${actionPath?.id}/edit/automatic/draft/step/1`}>Review Entrance Criteria</Link>
            )}

            {context === 'exit' && criteria?.context?.includes('exit') && (
              <Link href={`/action-paths/${actionPath?.id}/edit/automatic/draft/step/4`}>Review Exit Criteria</Link>
            )}
          </div>
        </Layout.Stack>
      </Box>
    </ErrorHandler>
  );
}
